'use client';

import { BaseTranslations } from '../../../baseTranslations';
import { CmsProduct } from '../../../types/cmsProduct';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { groupProductAttributes } from '../../../utils/helpers';
import { getClientTranslations } from '../../../utils/translations/getClientTranslations';
import { tr } from '../../../utils/translations/tr';
import BrandTagIcon from '../../icons/BrandTagIcon';
import { ProductDetailsAttributeList } from '../BaseComponents/ProductDetailsAttributeList';
import { ProductDetailsSectionHeader } from '../BaseComponents/ProductDetailsSectionHeader';

export const ProductDetailsSectionFees: React.FC<
  CmsProduct & { pushDataLayer?: PushDataLayerFn }
> = ({ pushDataLayer, ...product }) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);
  const { primaryFees, fullFeeSchedule, installmentFees } =
    groupProductAttributes(product);

  const sectionTitle = tr('fees_charges', staticText);

  return (
    <div className="flex flex-col gap-6">
      <ProductDetailsSectionHeader icon={<BrandTagIcon />}>
        {sectionTitle}
      </ProductDetailsSectionHeader>
      {primaryFees && primaryFees.length > 0 && (
        <ProductDetailsAttributeList
          attributes={primaryFees}
          product={product}
          pushDataLayer={pushDataLayer}
        />
      )}
      {fullFeeSchedule && fullFeeSchedule.length > 0 && (
        <ProductDetailsAttributeList
          attributes={fullFeeSchedule}
          dropdownSection={true}
          title={tr('full_fee_schedule', staticText).toUpperCase()}
          sectionTitle={sectionTitle}
          product={product}
          pushDataLayer={pushDataLayer}
        />
      )}
      {installmentFees && installmentFees.length > 0 && (
        <ProductDetailsAttributeList
          attributes={installmentFees}
          dropdownSection={true}
          title={tr('installment', staticText)}
          sectionTitle={sectionTitle}
          product={product}
          pushDataLayer={pushDataLayer}
        />
      )}
    </div>
  );
};
